import { render, staticRenderFns } from "./IndexPortal.vue?vue&type=template&id=44858f06&scoped=true"
import script from "./IndexPortal.vue?vue&type=script&lang=js"
export * from "./IndexPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44858f06",
  null
  
)

export default component.exports